import React, { useCallback, useEffect, useState } from 'react';
import './AddQuoteRider.scss';
import { Form } from 'devextreme-react';
import { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule } from 'devextreme-react/cjs/form';
import GlobalParams from '../../helpers/GlobalParams';
import notify from 'devextreme/ui/notify';

const AddQuoteRider = ({ onClosePopup, TotalMembers, DeathCoverBenefit, defaultForm }) => {

  console.log(defaultForm);
  const [vsBenefitLevel, setVsBenefitLevel] = useState(false);
  const [vsSalaryMultiplier, setVsSalaryMultiplier] = useState(false);
  const [vsPercApplicable, setVsPercApplicable] = useState(false);

  const [riderOptions, setRiderOptions] = useState(GlobalParams.riderOptions);
  
  const [riderStore, setRiderStore] = useState(defaultForm);
  
  const [isLoading, setIsLoading] = useState(false);

  const isRiderNotReapeted = (value) => {
    for(let rider in GlobalParams.AllRiders){
      if(rider['rider_code'] === value){
        return false;
      }
    }
    return true;
  }

  const calculateRiderPremium = () => {

  }

  const updateRiderStore = () => {
    console.log("updating the defaultform");
    setRiderStore(defaultForm);
    //isFormLoaded=false;
  }

  // if (isFormLoaded) {
  //   updateRiderStore();
  // }

  const ClearForm = () => {
    setRiderStore(defaultForm);
  }

  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };

  const doSave = useCallback(async (e) => {
    e.preventDefault();
    //console.log(quotationStore.HasDependants);


    //TODO perform the search here
    //console.log('Search clicked. Scheme:', riderStore.scheme_id);
    setIsLoading(true);
    //fetchData(searchStore.scheme_id, searchStore.name);
    //postData(memberStore);
    // Close the pop-up after the search is performed
    ClearForm();
    onClosePopup(riderStore);
    
  }, [riderStore]);

  return (
    <div>
      <form onSubmit={doSave}>
        <Form
          formData={riderStore} onContentReady={ () =>
            {
              console.log("at content ready");
              setRiderStore(defaultForm);
            }
          }>
          <GroupItem colCount={1} caption="">
            {/*RiderName, SumAssured, Premium */}


            <Item
              dataField="Rider"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.AllRiders,
                  displayExpr: "description",
                  valueExpr: "rider_code",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    //TODO-firstly check if selected rider is already selected before
                    if(isRiderNotReapeted(e.value)){
                      if (e.value !== undefined && e.value !== null && e.value !== '') {
                        setRiderStore((state) => {
                          return ({ ...state, RiderName: e.value })
                        });
                      }
                    }else{
                      //notify and clear the value
                      e.component.option('value', null);
                      notify('Rider already already Selected', 'error', 5000);
                    }
                    
                  }
                }
              }
            >
              <RequiredRule message="Rider Name is required" />
              <Label text='Rider' />
            </Item>


            <Item
              dataField="RiderOptions"
              visible={false}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: riderOptions,
                  displayExpr: "description",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //console.log(e.value);
                      setVsBenefitLevel(false);
                      setVsPercApplicable(false);
                      setVsSalaryMultiplier(false);
                      setRiderStore((state) => {
                        return ({ ...state, SalaryMultiplier: 0 })
                      });
                      setRiderStore((state) => {
                        return ({ ...state, PercApplicable: 0 })
                      });
                      setRiderStore((state) => {
                        return ({ ...state, BenefitLevel: 0 })
                      });

                      if(e.value === 2){
                        setVsPercApplicable(true);
                      }else if(e.value === 3){
                        setVsSalaryMultiplier(true);
                      }
                      else if(e.value === 1){
                        setVsBenefitLevel(true);
                      }

                      setRiderStore((state) => {
                        return ({ ...state, RiderOptions: e.value })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Rider Options is required" />
              <Label text='Rider Options' />
            </Item>

            <Item
              dataField="SalaryMultiplier"
              visible={false}
              editorType="dxNumberBox"
              // visible={vsSalaryMultiplier}
              editorOptions={
                {
                  format: ",##0.###",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);
                      let sa = (parseFloat(e.value.toString())) * parseFloat(DeathCoverBenefit.toString());
                      setRiderStore((state) => {
                        return ({ ...state, SalaryMultiplier: e.value })
                      });
                      setRiderStore((state) => {
                        return ({ ...state, SumAssured: sa })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Salary Multiplier is required" />
              <Label text='Salary Multiplier' />
            </Item>

            <Item
              dataField="PercApplicable"
              visible={false}
              editorType="dxNumberBox"
              //visible={vsPercApplicable}
              editorOptions={
                {
                  format: ",##0.###",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);
                      //calculate the sum assured
                      let sa = (parseFloat(e.value.toString())/100) * parseFloat(DeathCoverBenefit.toString());
                      setRiderStore((state) => {
                        return ({ ...state, PercApplicable: e.value })
                      });
                      setRiderStore((state) => {
                        return ({ ...state, SumAssured: sa })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Percentage Applicable is required" />
              <Label text='Percentage Applicable' />
            </Item>

            <Item
              dataField="BenefitLevel"
              visible={false}
              editorType="dxNumberBox"
              // visible={vsBenefitLevel}
              editorOptions={
                {
                  format: ",##0.###",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      let sa = (parseFloat(e.value.toString())) * parseFloat(TotalMembers.toString());
                      setRiderStore((state) => {
                        return ({ ...state, BenefitLevel: e.value })
                      });
                      setRiderStore((state) => {
                        return ({ ...state, SumAssured: sa })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Benefit Level is required" />
              <Label text='Benefit Level' />
            </Item>


            <Item
              dataField="SumAssured"
              visible={false}
              editorType="dxNumberBox"
              editorOptions={
                {
                  format: ",##0.###",
                  readOnly:true,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      // setRiderStore((state) => {
                      //   return ({ ...state, SumAssured: e.value })
                      // });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Rider Benefit is required" />
              <Label text='Rider Benefit' />
            </Item>

            {/* <Item
              dataField="PremiumRate"
              editorType="dxNumberBox"
              editorOptions={
                {
                  format: ",##0.###",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      let premium = (parseFloat(e.value.toString()) / 1000) * parseFloat(riderStore.SumAssured.toString().replace(/,/g, ''));

                      setRiderStore((state) => {
                        return ({ ...state, PremiumRate: e.value })
                      });
                      setRiderStore((state) => {
                        return ({ ...state, Premium: premium })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="PremiumRate is required" />
              <Label text='Premium Rate' />
            </Item>

            <Item
              dataField="Premium"
              editorType="dxNumberBox"
              editorOptions={
                {
                  format: ",##0.###",
                  readOnly:true,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);
                    }
                  }
                }
              }
            >
              <RequiredRule message="Premium is required" />
              <Label text='Rider Premium' />
            </Item> */}


            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />


            <ButtonItem
              colSpan={1}
            >
              <ButtonOptions type='default' text="SAVE" icon='save' useSubmitBehavior={true} />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </div>
  );

}
//export default AddQuoteRider;
export default React.memo(AddQuoteRider, () => false);